import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textSearch',
  standalone: true,
})
export class TextSearchFilterPipe implements PipeTransform {
  transform(searchItems: any[], searchText: string): any[] {
    if (!searchItems) return [];
    if (!searchText) return searchItems;
    searchText = searchText.toLowerCase();

    return searchItems.filter((item) => {
      if (typeof item === 'string') {
        return item.toLowerCase().includes(searchText);
      } else {
        return Object.entries(item).some(([key, value]) => {
          if (key === 'id') return false;
          if (typeof value === 'string') {
            return value.toLowerCase().includes(searchText);
          }
          return false;
        });
      }
    });
  }
}
